export default {
  title: 'Reserveringen CSV',
  buttons: {
    generate: 'Genereren & downloaden',
  },
  fields: {
    date_range: 'Datumbereik (optioneel)',
  },
  errors: {
    invalid_date_range: 'Selecteer een geldig datumbereik',
  },
};
